export default {
    new_0:{
        en:'spotlight Events',
        tc:'焦點盛事',
        sc:'焦点盛事'
    },
    new_back:{
        en:'back',
        tc:'返回',
        sc:'返回'
    }
}